// extracted by mini-css-extract-plugin
export default {"outsideBox":"progress-bar_outsideBox__Z61G8","insideBox":"progress-bar_insideBox__458A6","runningOutTimeColor":"progress-bar_runningOutTimeColor__1Tbbn"};